import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { NodeComponent } from "@app/workflow-common/diagram-view2/node/node.component";
import { SidepanelModalService } from "@app/sidepanel/services/sidepanel-modal.service";
import { DiagramService } from "@app/workflow-common/diagram-view2/services/diagram.service";
import { TranslateService } from "@ngx-translate/core";
import { TriggerDatasetService } from "@app/workflow-common/services/trigger-dataset.service";
import { combineLatest, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TriggerConditionPanelComponent } from "@app/workflow-common/diagram-view2/panels/trigger-condition-panel/trigger-condition-panel.component";
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
var NodeRootComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NodeRootComponent, _super);
    function NodeRootComponent(modalService, changeDetection, diagramService, translateService, triggerService, confirmationBoxHelper, ajsScope, workflowHttp, document) {
        var _this = _super.call(this, modalService, changeDetection, diagramService, translateService, triggerService, confirmationBoxHelper, ajsScope, workflowHttp, document) || this;
        _this.modalService = modalService;
        _this.changeDetection = changeDetection;
        _this.diagramService = diagramService;
        _this.translateService = translateService;
        _this.triggerService = triggerService;
        _this.confirmationBoxHelper = confirmationBoxHelper;
        _this.ajsScope = ajsScope;
        _this.workflowHttp = workflowHttp;
        _this.document = document;
        _this.unsubscribeAll = new Subject();
        _this.nodeSubTitlePrefix = '';
        _this.onHighlight = '';
        _this.isAuditHightlight = false;
        _this.dependentId = '';
        _this.conditions = 'AND';
        _this.mainObjectName = '';
        return _this;
    }
    NodeRootComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isRoot = this.id == 'cs_initializer';
        this.block_name = this.name;
        this.operatorsDisplayText = this.triggerService.getOperatorsDisplayText();
        combineLatest(this.diagramService.diagram$)
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe(function (_a) {
            var nodeParams = _a[0];
            if (nodeParams) {
                var nodeOptions = nodeParams.nodeOptions;
                _this.nodeOptions = nodeOptions;
                _this.viewMode = _this.nodeOptions.viewMode;
                if (_this.viewMode == 'history' && _this.nodeOptions.tasksStatus && _this.nodeOptions.tasksStatus.hasOwnProperty(_this.id)) {
                    _this.taskStatus = _this.nodeOptions.tasksStatus[_this.id];
                }
                if (_this.viewMode == 'audit') {
                    _this.isAuditHightlight = _this.nodeOptions.audit['taskId'].includes(_this.id);
                }
                var metaData = _this.nodeOptions.metaData;
                if (metaData['screenName'] == 'customForm') {
                    _this.nodeSubTitlePrefix = 'Custom form is ';
                }
                else {
                    _this.nodeSubTitlePrefix = '';
                }
            }
        });
    };
    NodeRootComponent.prototype.showTriggerPanel = function (isEdit) {
        var _this = this;
        if (isEdit === void 0) { isEdit = false; }
        var _a = this.nodeOptions, metaData = _a.metaData, objectName = _a.objectName, workflowType = _a.workflowType;
        var fields = metaData.fields;
        var initialState = {
            title: this.translateService.instant('Trigger conditions'),
            fields: fields,
            objectName: objectName,
            workflowType: workflowType,
            dagSourceModel: this.dagSourceModel,
            isEdit: isEdit,
            rules: this.rules
        };
        var triggerPanelRef = this.showHideSidePanel(initialState, TriggerConditionPanelComponent);
        triggerPanelRef.content.onClose.subscribe(function (data) {
            if (data.action == 'close') {
            }
            else if (data.action == 'add' || data.action == 'edit') {
                if (data.action == 'add') {
                    _this.dagSourceModel.addTask(data['node']);
                }
                else {
                    _this.dagSourceModel.updateRootTask(data['node']);
                }
                var _a = data['node'], id = _a.id, rules = _a.rules, conditions = _a.conditions, parentId = _a.parentId, block_name = _a.block_name, name_1 = _a.name, mainObject = _a.mainObject, dependentId = _a.dependentId;
                _this.id = id;
                _this.rules = rules;
                _this.conditions = conditions;
                _this.parentId = parentId;
                _this.name = name_1;
                _this.blockId = _this.id;
                _this.mainObjectName = mainObject;
                _this.diagramService.isNodeUpdated();
                _this.diagramService.autoSave(true);
                _this.onHighlight = 'on';
            }
            triggerPanelRef.hide();
        });
    };
    NodeRootComponent.prototype.editNode = function () {
        if (this.viewMode == 'history') {
            this.showHistoryTaskStatus();
        }
        else if (this.viewMode == 'form') {
            this.showTriggerPanel(true);
        }
    };
    NodeRootComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeAll.next(null);
        this.unsubscribeAll.complete();
        this.unsubscribe();
    };
    return NodeRootComponent;
}(NodeComponent));
export { NodeRootComponent };
